module.exports = __webpack_public_path__ + "static/media/overpass-heavy.33b983b6.woff2";